import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import CustomButtonCancel from "./CustomButtonCancel";
import CustomButtonSave from "./CustomButtonSave";

const CustomEditRemoveIcon = ({ ...props }) => {
  const message =
    props?.message ||
    'Are you sure you want to permanently remove this item? Click "Confirm" to proceed.';
  const color = props?.color || "red";
  const size = props?.size || "22px";
  const disabled = props?.disabled || false;
  const fileSrc = "/public/icon/action-delete.svg";
  const [open, setOpen] = useState(false);

  if (disabled) {
    return (
      <Tooltip title={props?.label || "Delete"} placement="left" arrow>
        <IconButton disabled={true}>
          <div
            style={{
              width: size,
              height: size,
              // marginLeft: "10px",
              display: "inline-block",
              verticalAlign: "middle",
              backgroundColor: color,
              maskImage: "url(" + fileSrc + ")",
              maskSize: "contain",
              WebkitMaskImage: "url(" + fileSrc + ")",
              WebkitMaskSize: "contain",
              WebkitMaskRepeat: "no-repeat",
              maskRepeat: "no-repeat",
            }}
          />
        </IconButton>
      </Tooltip>
    );
  }
  return (
    <>
      <Tooltip title={props?.label || "Remove"} placement="left" arrow>
        <IconButton onClick={() => setOpen(true)}>
          <div
            style={{
              width: size,
              height: size,
              // marginLeft: "10px",
              display: "inline-block",
              verticalAlign: "middle",
              backgroundColor: color,
              maskImage: "url(" + fileSrc + ")",
              maskSize: "contain",
              WebkitMaskImage: "url(" + fileSrc + ")",
              WebkitMaskSize: "contain",
              WebkitMaskRepeat: "no-repeat",
              maskRepeat: "no-repeat",
            }}
          />
        </IconButton>
      </Tooltip>
      <Dialog
        fullWidth={true}
        maxWidth="xs"
        open={open}
        onClose={() => setOpen(false)}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            borderBottom: "1px solid #e5e5e5",
            color: "#465384",
            textTransform: "uppercase",
          }}
        >
          Remove
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mt: "20px", mb: "20px" }}>
            {message}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={() => setOpen(false)} label="Cancel" />
          <CustomButtonSave onClick={props?.onClick} label="Confirm" />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CustomEditRemoveIcon;
